module.exports = {};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3975732384/src/~/core-js/modules/_iterators.js
// module id = lexG
// module chunks = 1